/* istanbul ignore file */
import React, { useState, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Next from '../../assets/svg/icons-chevron-up.svg';
import Prev from '../../assets/svg/icons-chevron-up.svg';
import * as styles from './VerticalCarousel.css';

const cx = classNames.bind(styles);

const VerticalCarousel = (props) => {
    const intialActiveIndex = 4;
    const [activeIndex, setActiveIndex] = useState(intialActiveIndex);
    const [tranformXvalueNext, setTranformXvalueNext] = useState(0);

    const handleClick = (direction) => {
        setActiveIndex((prevIndex) => {
            if (direction === 'next') {
                if (prevIndex + 1 > Children.toArray(props?.children).filter(Boolean).length - 1) {
                    return 0;
                }
                setTranformXvalueNext((prevTranformXvalueNext) => {
                    return prevTranformXvalueNext + 121;
                });
                return prevIndex + 1;
            }
            if (direction === 'prev') {
                if (prevIndex - 1 < 0) {
                    return Children.toArray(props?.children).filter(Boolean).length - 1;
                }
                setTranformXvalueNext((prevTranformXvalueNext) => {
                    return prevTranformXvalueNext - 121;
                });
                return prevIndex - 1;
            }
        });
    };

    const childrenLength = Children.toArray(props?.children).filter(Boolean).length;
    const isPrevButtonEnabled =
        childrenLength > 5 && activeIndex !== intialActiveIndex && activeIndex !== 0;
    const isNextButtonEnabled = childrenLength > 5 && activeIndex !== childrenLength - 1;

    return (
        <div className={cx('container')}>
            <section className={`${cx('outer-container')} ${dt(['flex', 'm-auto'])}`}>
                <div className={`${cx('carousel-wrapper')} ${dt(['flex', 'flex-col', 'flex-1'])}`}>
                    {/* { isPrevButtonEnabled && */}
                    <button
                        type="button"
                        className={`${cx('carousel-button', 'prev')} ${dt([
                            'flex',
                            'self-center',
                            'w-8',
                            'h-8',
                            'mb-4',
                        ])}`}
                        onClick={() => isPrevButtonEnabled && handleClick('prev')}
                    >
                        {isPrevButtonEnabled && (
                            <Icon
                                iconType="svg"
                                className="arrow-icon"
                                width="32px"
                                height="32px"
                                viewBox="0 0 32 32"
                            >
                                <Prev />
                            </Icon>
                        )}
                    </button>

                    <div className={`${cx('carousel')} ${dt([''])}`}>
                        <div
                            className={`${cx('slides')} ${dt([
                                'self-start',
                                'flex-1',
                                'w-full',
                                'overflow-hidden',
                            ])}`}
                        >
                            <div
                                className={` ${cx('carousel-inner')} ${dt([
                                    childrenLength > 3 ? '' : 'lg:!h-[426px]',
                                ])} `}
                            >
                                {Children.map(props?.children, (child, index) =>
                                    child ? (
                                        <button
                                            type="button"
                                            className={`${cx('carousel-item', {
                                                active: activeIndex === index,
                                                visible: true,
                                            })} ${dt([
                                                'p-0',
                                                'm-0',
                                                'opacity-0',
                                                'top-28',
                                                'w-full',
                                            ])}`}
                                            key={index}
                                            style={{
                                                transform: `translateY(-${tranformXvalueNext}px)`,
                                                transition: '200ms ease 0s',
                                            }}
                                        >
                                            {cloneElement(child, null)}
                                        </button>
                                    ) : null
                                )}
                            </div>
                        </div>
                    </div>
                    {isNextButtonEnabled && (
                        <button
                            type="button"
                            className={`${cx('carousel-button', 'next')} ${dt([
                                'flex',
                                'self-center',
                                'w-8',
                                'h-8',
                                'mb-4',
                                'rotate-180',
                            ])}`}
                            onClick={() => handleClick('next')}
                        >
                            <Icon
                                iconType="svg"
                                className="arrow-icon"
                                width="32px"
                                height="32px"
                                viewBox="0 0 32 32"
                            >
                                <Next />
                            </Icon>
                        </button>
                    )}
                </div>
            </section>
        </div>
    );
};

VerticalCarousel.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default VerticalCarousel;
